import { render, staticRenderFns } from "./BettingResult.vue?vue&type=template&id=9e8e4288&scoped=true"
import script from "./BettingResult.vue?vue&type=script&lang=js"
export * from "./BettingResult.vue?vue&type=script&lang=js"
import style0 from "./BettingResult.vue?vue&type=style&index=0&id=9e8e4288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8e4288",
  null
  
)

export default component.exports